import styled from "styled-components/macro";

// export const PopUpBox = styled.div`
// height: 272px;
// width: 100%;
// `

export const PopUpBox = styled.div`
  /* grid-area: smartkeys; */
  background: var(--clr-settingsbg);
  height: ${({ full }) => full && "276px"};
  /* height: 277px; */
  /* height: 88%; */
  height: 100%;
`;

export const PopUpHeadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  /* font-size: 1.5rem; */
  font-size: 1rem;

  gap: 1em;
  margin-left: -1em;
  /* margin: 1em; */
  padding-top: 1em;
`;

export const PopUpIconWrapper = styled.div``;

// Icon (maybe create icon wrapper )

// change font size if needed
export const PopUpTitle = styled.div``;

export const PopUpBodyText = styled.div`
  margin-left: 1em;
  margin-right: 1em;
`;

export const PopUpStandbyMessage = styled.div`
  margin: 0;
  padding: 0 0.3em;
`;
export const PopUpStandbyWrapFlexContainer = styled.div`
  border-top: 1px solid white;
  border-bottom: 1px solid white;

  padding: 0.75em 0;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
`;
export const PopUpStandbyWrapFlex = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5em;
`;
export const TelemetryButton = styled.button`
  padding: 1em 1.5em;
  border: #414340;

  background: gray;

  color: #edebeb;
  border-top-left-radius: 7px;
  border-bottom-left-radius: 7px;

  &:focus {
    background-color: #1f729f;
  }
`;

export const PopUpStandByButtonCancel = styled(TelemetryButton)`
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
  background-color: #8f9395;
  padding: 0.5em 1.5em;
  display: inline;

  &:focus {
    background-color: #1f729f;
  }
`;
export const PopUpStandByButtonConfirm = styled(TelemetryButton)`
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
  background-color: #1f729f;
  padding: 0.5em 1.5em;
  display: inline;

  &:focus {
    background-color: #1f729f;
  }
`;

export const PopUpButtonWrapper = styled.div`
  padding-right: 1em;
  display: flex;
  justify-content: flex-end;

  margin-top: 1em;
  gap: 0.5em;
`;
